/* esm.sh - applesauce-core@5.2.0/helpers/hidden-content */
export * from "/*applesauce-core@5.2.0/esnext/helpers/hidden-content.mjs";
